export default __webpack_public_path__ + "static/media/img2.e23ac2d0.jpg";